module.exports = __webpack_public_path__ + "img/logo.2ed736f5.png";